import { useEffect } from 'react'
import { observer } from 'mobx-react'
import { Button } from 'antd'
import { ProductOutlined, MenuOutlined } from '@ant-design/icons'
import { FormPage } from 'src/components'
import { ChartTable } from './components'
import { layoutStore } from 'enasops/stores'
import 'enasops/styles/op/100/index.less'

const ModeChanger = observer(() => {
  const { active } = layoutStore.slotData
  const isChart = active === 'chart'
  return (
    <div className='text-right'>
      <Button
        type={isChart ? 'primary' : 'default'}
        icon={<ProductOutlined />}
        onClick={() => layoutStore.updateSlotData({ active: 'chart' })}
        className='mg-r8'
      >图形模式</Button>
      <Button
        type={isChart ? 'default' : 'primary'}
        icon={<MenuOutlined />}
        onClick={() => layoutStore.updateSlotData({ active: 'list' })}
      >列表模式</Button>
    </div>
  )
})

const OP100 = () => {
  useEffect(() => {
    layoutStore.setSlot(<ModeChanger />, { active: 'chart' })

    return () => {
      layoutStore.removeSlot()
    }
  }, [])

  const { active } = layoutStore.slotData
  const isChart = active === 'chart'
  return isChart ? <ChartTable /> : <FormPage formCode='OP028' />
}

export default observer(OP100)